export default {
  functionKey: "EXTRAIRE INTERVALLE",
  title: "EXTRAIRE INTERVALLE",
  group: "Parsing",
  origin: [],
  target: [],
  arguments: [],
  maxArguments: 2,
  requiredArguments: [
    { argumentKey: "Start", name: "Intervalle inférieur" },
    { argumentKey: "End",   name: "Intervalle supérieur" }
  ],
  expectedArguments: [
    { name: "Intervalle inférieur", argumentKey: "Start", single: true, initialValue: "" },
    { name: "Intervalle supérieur", argumentKey: "End",   single: true, initialValue: "" }
  ],
  description: "Extraire du texte entre deux valeurs (Ex: (EXTRAIRE INTERVALLE 'helloworld', 'hel', 'rld') -> 'ellowo')",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    if (args.length < 2) return { displayCode: "", safeCode: "" };

    // strip surrounding quotes
    let start = args[0];
    if (start.startsWith("'")) start = start.substr(1);
    if (start.endsWith("'"))   start = start.substring(0, start.length - 1);

    let end = args[1];
    if (end.startsWith("'")) end = end.substr(1);
    if (end.endsWith("'"))   end = end.substring(0, end.length - 1);

    const displayCode = `${destination} = ${origin}.match(/(?<=${start})(.*)(?=${end})/g);`;
    const safeCode    = `${destination} = ${origin}.match(/(?<=${start})(.*)(?=${end})/g)?.[0] ?? '';`;

    return { displayCode, safeCode };
  }
}
